import React, { useState } from "react";
import { Select } from "antd";
import { Button, Message, Input, Upload } from "../../../BP2Components";
import { useDispatch } from "react-redux";
import { setWidgetInSheetParams } from "appRedux/actions/Actions";
import IntlMessages from "@util/IntlMessages";
import { SketchPicker } from "react-color";
import { getListStructure } from "services/api/Api";
import { sendFile, deleteFile, sendFileToCloudStorage } from "services/restAPI/RestApi";
import { useIntl } from "react-intl";
import { getBase64StringFromDataURL } from "../../../../util/Scripts";

const { Option } = Select;

const SummarySettings = ({ value, columns }) => {
   const dispatch = useDispatch();
   const intl = useIntl();

   const [settings, setSettings] = useState({
      ...value,
      columns: columns,
   });

   const handleDeletePhoto = () => {
      Message.loading(intl.formatMessage({ id: "global.loading" }), 0);
      if (settings.imageFileId && !settings.imageSourceURL) {
         deleteFile(settings.imageFileId)
            .then(() => {
               setSettings({
                  ...settings,
                  imageFileId: null,
               });
               Message.success(intl.formatMessage({ id: "global.done" }));
            })
            .catch(() => {
               Message.error(intl.formatMessage({ id: "global.error" }));
            })
            .finally(() => {
               Message.destroy();
            });
      } else {
         setSettings({
            ...settings,
            imageFileId: null,
            imageSourceURL: null,
         });
         Message.destroy();
      }
   };

   const handleUploadFile = (info) => {
      if (!info.type.startsWith("image/")) {
         Message.error(intl.formatMessage({ id: "forms.wrongFileType" }));
         return;
      }

      const cleanedType = info.type.replace(/^image\//, "");
      const reader = new FileReader();

      reader.onload = function (loadEvent) {
         const result = loadEvent.target.result;
         const base64 = getBase64StringFromDataURL(result);
         if (base64) {
            Message.loading(intl.formatMessage({ id: "global.loading" }));
            try {
               sendFileToCloudStorage(info.name, cleanedType, base64).then((res) => {
                  setSettings({
                     ...settings,
                     imageSourceURL: res?.data?.cloudStorage?.url,
                  });
               });
               Message.success(`${intl.formatMessage({ id: "forms.uploadSucces" })} ${info.name}`);
            } catch (error) {
               console.log(error);
               Message.error(intl.formatMessage({ id: "forms.uploadFailed" }));
            } finally {
               Message.destroy();
            }
         }
      };
      reader.readAsDataURL(info);
   };

   const handleSubmit = (e) => {
      e.preventDefault();

      dispatch(setWidgetInSheetParams(settings));
      Message.success(intl.formatMessage({ id: "global.saved" }));
   };
   const handleChangeList = (e) => {
      getListStructure(settings.listId).then((res) => {
         const responseData = res.data.getStructure;
         if (responseData.columns) {
            setSettings({
               ...settings,
               columns: responseData.columns,
            });
         }
      });
   };
   const handleChange = (e) => {
      setSettings({ ...settings, [e.target.name]: e.target.value });
   };
   const handleChangeInput = (name) => (value) => {
      setSettings({ ...settings, [name]: value });
   };

   const handleDefaultColor = (type) => {
      if (type === "textColor") {
         setSettings({ ...settings, textColor: "#000" });
      } else {
         setSettings({ ...settings, backgroundColourHex: "#fff" });
      }
   };

   const [displayColorPicker, setDisplayColorPicker] = useState(false);
   const [displayColorPickerText, setDisplayColorPickerText] = useState(false);

   const togglePicker = (type) => {
      if (type === "textColor") {
         setDisplayColorPickerText(!displayColorPickerText);
      } else {
         setDisplayColorPicker(!displayColorPicker);
      }
   };

   const handleChangeColor = (name) => (color) => {
      setSettings({ ...settings, [name]: color.hex });
   };
   const overwriteDefaultUploadFunction = ({ file, onSuccess }) => {
      setTimeout(() => {
         onSuccess("ok");
      }, 0);
   };

   const handleSelectFile = (info) => {
      var formData = new FormData();
      if (info.file.status !== "uploading") {
      }
      if (info.file.status === "done") {
         Message.success(`${info.file.name} ${(<IntlMessages id="forms.uploadSucces" />)}`);

         formData.append("multipartFile", info.file.originFileObj);
         sendFile(formData).then((res) => {
            setSettings({
               ...settings,
               imageFileId: res.data,
            });
         });
      } else if (info.file.status === "error") {
         Message.error(`${info.file.name} ${(<IntlMessages id="forms.uploadFailed" />)}`);
      }
   };
   const options =
      settings && settings.columns != null
         ? settings.columns.map((col) => (
              <Option key={col.label} value={col.label}>
                 {col.label}
              </Option>
           ))
         : null;
   return (
      <>
         <form onSubmit={handleSubmit}>
            <div className="widget-settings">
               <div key="Set" className="widget-settings__inner">
                  <label key="title" className="widget-settings__inner__label">
                     <IntlMessages id="settings.listId" />:
                     <div style={{ display: "flex" }}>
                        <Input
                           type="text"
                           name="listId"
                           value={settings.listId}
                           onChange={handleChange}
                           style={{ width: "100px" }}
                        />
                        <Button className="gx-ml-1" buttonType="primary" onClick={handleChangeList}>
                           <IntlMessages id="settings.changeId" />
                        </Button>
                     </div>
                  </label>
                  <label className="widget-settings__inner__label" key="itemsPerPage">
                     <IntlMessages id="settings.itemsPerPage" />:
                     <Input
                        type="itemsPerPage"
                        name="itemsPerPage"
                        onChange={handleChange}
                        value={settings.itemsPerPage}
                     />
                  </label>
                  <label className="widget-settings__inner__label" key="description">
                     <IntlMessages id="settings.description" />:
                     <Input
                        type="description"
                        name="description"
                        style={{ width: 220 }}
                        onChange={handleChange}
                        value={settings.description}
                     />
                  </label>
                  <label className="widget-settings__inner__label" key="columnToSummarize">
                     <IntlMessages id="settings.columnToSummarize" />:
                     <Select
                        value={settings.columnToSummarize || "----Select----"}
                        style={{ width: 220 }}
                        onChange={handleChangeInput("columnToSummarize")}
                     >
                        <Option value="----Select----">----Select----</Option>
                        {options}
                     </Select>
                  </label>
                  <div className="widget-settings__inner__label" key="file">
                     <IntlMessages id="settings.upload" />:
                     <div style={{ display: "flex", gap: "10px" }}>
                        <Upload onUpload={handleUploadFile} disabled={settings.imageSourceURL}>
                           <Button buttonType={settings.imageSourceURL ? "disabled" : "default"}>
                              <IntlMessages id="settings.upload" />
                           </Button>
                        </Upload>
                        <Button
                           onClick={handleDeletePhoto}
                           buttonType={
                              settings.imageSourceURL || settings.imageFileId
                                 ? "default"
                                 : "disabled"
                           }
                        >
                           <IntlMessages id="delete" />
                        </Button>
                     </div>
                     {settings.imageSourceURL ? (
                        <div className="gx-mt-2">
                           <img
                              src={settings.imageSourceURL}
                              alt=""
                              style={{ maxWidth: "100px" }}
                           />
                        </div>
                     ) : null}
                  </div>
                  <label className="widget-settings__inner__label" key="xsImageSize">
                     <IntlMessages id="settings.buttonImageWidth" />:
                     <Input
                        type="number"
                        name="xsImageSize"
                        onChange={handleChange}
                        value={settings.xsImageSize}
                     />
                  </label>
                  <label className="widget-settings__inner__label" key="smImageSize">
                     <IntlMessages id="settings.imageHeight" />:
                     <Input
                        type="number"
                        name="smImageSize"
                        onChange={handleChange}
                        value={settings.smImageSize}
                     />
                  </label>
                  <label className="widget-settings__inner__label" key="textColor">
                     <IntlMessages id="settings.textColor" />:
                     <div>
                        <Button
                           buttonType="primary"
                           onClick={() => togglePicker("textColor")}
                           className="cp-color"
                           style={{ backgroundColor: settings.textColor }}
                        >
                           <IntlMessages id="settings.clickToChangeColor" />
                        </Button>

                        <Button onClick={() => handleDefaultColor("textColor")}>
                           <IntlMessages id="settings.setDefaultColor" />
                        </Button>
                     </div>
                     {displayColorPickerText && (
                        <div className="cp-popover">
                           <div className="cp-cover" />
                           <SketchPicker
                              color={settings.textColor}
                              onChange={handleChangeColor("textColor")}
                           />
                        </div>
                     )}
                  </label>
               </div>
               <Button buttonType="primary" htmlType="submit">
                  <IntlMessages id="global.preview" />
               </Button>
            </div>
         </form>
      </>
   );
};

export default SummarySettings;
